// import {
//   type ChangeEventHandler,
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";

import clsx from "clsx";

import { SalesTable } from "./sales-table";
import { Tabs } from "./tabs";

// import clsx from "clsx";
// import {
//   cloneDeep,
//   compact,
//   difference,
//   sortBy,
//   sortedUniq,
//   uniq,
// } from "lodash";

// import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";
// import { Autocomplete, TertiaryIconButton } from "@components/v2";
// import { createColumnHelper, Table } from "@components/v2/table";
// import {
//   makeAdKeyDimension,
//   makeBreakdownDimension,
//   makeNameDimension,
// } from "@features/sales-v4/dimensions";
// import { type DimensionDefinition } from "@features/sales-v4/types";
// import {
//   SALES_METRICS_COUNT_V4,
//   SALES_METRICS_REPORT_V4,
// } from "@gql/sales-page-v4";
// import { useNorthbeamLazyQuery } from "@hooks/http";
// import {
//   type GetSalesMetricsCountV4,
//   type GetSalesMetricsCountV4Variables,
//   type GetSalesMetricsReportV4,
//   type GetSalesMetricsReportV4Variables,
//   type SalesTableReportV3BreakdownsFilterInput,
// } from "@north-beam/nb-client-side";
// import {
//   makeDistinctAdKeyCount,
//   type SalesMetricV2,
// } from "@north-beam/nb-client-side/metrics-v2";
// import { jsonHash } from "@north-beam/nb-common";
// import {
//   type SalesMetricRow,
//   type SalesMetricValues,
// } from "@north-beam/nb-common/metrics-v2";
// import { CustomCheckbox } from "@shared/custom-checkbox";
// import { type CellContext, type ExpandedState } from "@tanstack/react-table";

// import { useSalesPageV3NextContext } from "../sales-v3-next-provider";

// const LIMIT = 30;

// interface TableSpinnerRow {
//   type: "spinner";
//   nesting: string;
//   level: number;
//   id: string;
// }

// interface TableLoadMoreRow {
//   type: "load-more";
//   nesting: string;
//   level: number;
//   id: string;
// }

// interface TableReportRow {
//   type: "report";
//   nesting: string;
//   level: number;
//   id: string;
//   name: string;
//   actualMetrics: SalesMetricValues;
// }

// type TableRow = TableReportRow | TableLoadMoreRow | TableSpinnerRow;

// interface NestingState {
//   page: number;
//   rows: TableRow[];
// }

// interface RowSelection {
//   id: string;
//   path: string[];
//   type: "inclusion" | "exclusion";
// }

export const TableContent = () => {
  return (
    <div>
      {/* <ConfigurationDetailsModal
        columnConfigs={columns}
        metrics={metrics}
        isOpen={isConfigurationDetailsModalOpen}
        onClose={onCloseConfigurationDetailsModal}
      /> */}
      <div className="float-right flex flex-row space-x-2">
        {/* {hasFeatureFlag("customMetricsV1") && <CustomMetrics />} */}
        {/* <CustomizeTableModal metrics={metrics} /> */}
        {/* <IconButton
          className="font-semibold tracking-wide leading-5"
          variant="secondary"
          leftIcon={<i className="fa-regular fa-sharp fa-download" />}
          onClick={() => setExportModalOpened(true)}
        >
          EXPORT TABLE
        </IconButton> */}
        {/* <ExportTableModal
          exportModalOpened={exportModalOpened}
          setExportModalOpened={setExportModalOpened}
        /> */}
        {/* <TableViewSelector /> */}
      </div>
      <div className="w-[420px] mt-8 mb-4">{/* <SearchForm /> */}</div>
      <Tabs />
      <div
        className={clsx(
          "h-[45rem] border-l-1 border-r-1 border-b-1 border-gray-0 relative",
        )}
      >
        <SalesTable
        // loadMore={loadMore}
        // headingRow={headingRowVisualized}
        // loading={loading}
        // columns={columnsWithBenchmarks}
        // rows={tableRows}
        // maxIndentLevel={maxIndentLevel}
        // onDimensionCellClick={(row) => {
        //   if (activeTab === "ad") {
        //     return;
        //   }
        //   let toTabId: TabId;

        //   const key = JSON.parse(row.key);
        //   const isBreakdownRow = Array.isArray(key);
        //   const currentDepth = breakdowns.findIndex(
        //     (b) => b.key === row.rowMetadata.breakdown,
        //   );

        //   const noBreakdowns = Array.isArray(key)
        //     ? (key as Dimensions[]).every((k) => !Object.keys(k).length) ||
        //       (breakdowns.length > 0 &&
        //         currentDepth !==
        //           Object.keys(row.rowMetadata.dimensions).length - 1)
        //     : false;

        //   if (noBreakdowns) {
        //     addToast("Uncategorized is not searchable", {
        //       appearance: "info",
        //     });
        //     return;
        //   }

        //   if (activeTab === "breakdown") {
        //     toTabId = "campaign";
        //   } else if (activeTab === "campaign") {
        //     toTabId = "adset";
        //   } else {
        //     toTabId = "ad";
        //   }

        //   const newProposedState = {
        //     inclusionAtomicities: isBreakdownRow
        //       ? [
        //           {
        //             atomicity: row.key,
        //             count: row.rowMetadata.deepestAtomicityCounts,
        //           },
        //         ]
        //       : [],
        //     inclusionAdKeys: !isBreakdownRow
        //       ? [
        //           {
        //             adKey: row.key,
        //             dimensions: row.rowMetadata.dimensions,
        //           },
        //         ]
        //       : [],
        //     exclusionAtomicities: [],
        //     exclusionAdKeys: [],
        //   } as FiltersState;

        //   tabStates[activeTab].setTabState((toTabState) => {
        //     return {
        //       ...toTabState,
        //       proposedFiltersState: newProposedState,
        //       selectAll: false,
        //     };
        //   });

        //   const platformDimension =
        //     row.rowMetadata.dimensions["Platform (Northbeam)"];
        //   if (platformDimension) {
        //     setTabTopPlatforms([platformDimension]);
        //   }

        //   tabStates[toTabId].setTabState((toTabState) => {
        //     const currentTabState = tabStates[activeTab].tabState;

        //     // reconcile the states
        //     const reconciledStates = reconcileAppliedAndProposedTabFilters(
        //       currentTabState.appliedFiltersState ?? null,
        //       newProposedState,
        //       isDefaultSelectAll,
        //     );

        //     const { toAddExclusions, appliedAdKeyFilters } =
        //       enrichInclusionsAndExclusions({
        //         breakdowns,
        //         reconciledStates,
        //         currentTabState,
        //       });

        //     const newTabState = {
        //       ...toTabState,

        //       selectAll: false,
        //       preselectionDone: false,
        //       appliedFiltersState: {
        //         // apply the reconciled state between the current
        //         inclusionAtomicities: reconciledStates.inclusionAtoms,
        //         exclusionAtomicities: [
        //           ...reconciledStates.exclusionAtoms,
        //           ...toAddExclusions,
        //         ],
        //         campaignExclusionAdKeys:
        //           currentTabState?.appliedFiltersState
        //             ?.campaignExclusionAdKeys,
        //         campaignInclusionAdKeys:
        //           appliedAdKeyFilters?.campaignInclusionFilters,
        //         adsetInclusionAdKeys:
        //           appliedAdKeyFilters?.adsetInclusionFilters,
        //         adsetExclusionAdKeys:
        //           currentTabState?.appliedFiltersState?.adsetExclusionAdKeys,
        //         ...(!isBreakdownRow && {
        //           [`${activeTab}InclusionAdKeys`]: [
        //             {
        //               adKey: row.key,
        //               dimensions: row.rowMetadata.dimensions,
        //             },
        //           ],
        //         }),
        //       },
        //     } as TabState;

        //     prettyLogEventPage({
        //       domain: "Sales Page V3",
        //       action: "onClick",
        //       additionalActionInfo: "cell-tab-state-change",
        //     });
        //     return newTabState;
        //   });

        //   onActivate(toTabId);

        //   if (isBreakdownRow) {
        //     const breakdownKeys = JSON.parse(row.key) as Dimensions[];
        //     if (!breakdownKeys.length) {
        //       return;
        //     }
        //     const expandedIds = breakdownKeys.map((_, index) => {
        //       return JSON.stringify(breakdownKeys.slice(0, index + 1));
        //     });

        //     setExpandedRowIds(expandedIds);
        //   } else {
        //     const dimensions = row.rowMetadata.dimensions as Dimensions;
        //     const breakdownPaths = breakdowns.map((_, index) =>
        //       JSON.stringify(
        //         breakdowns.slice(0, index + 1).map((b) => {
        //           return { [b.key]: dimensions[b.key] };
        //         }),
        //       ),
        //     );

        //     setExpandedRowIds([...breakdownPaths]);
        //   }
        // }}
        />
      </div>
    </div>
  );

  // const {
  //   attributionModel,
  //   attributionWindow,
  //   accountingMode,
  //   timeGranularity,
  //   granularity,
  // } = useSalesPageV3NextContext();
  // const { value: breakdowns } = useSalesBreakdownConfigs();
  // const columnHelperWrapper = createColumnHelper<TableRow>();
  // const [selectedBreakdowns, setSelectedBreakdowns] = useState<string[]>([]);
  // const [flatRows, setFlatRows] = useState<Record<string, NestingState>>({
  //   root: { page: 0, rows: [] },
  // });
  // const [rowSelection, setRowSelection] = useState<RowSelection[]>([]);
  // const [expanded, setExpanded] = useState<ExpandedState>({});
  // const [jsonLogic, setJsonLogic] = useState<any>(null);
  // const breakdownDimensions = useMemo(() => {
  //   return selectedBreakdowns.map((e) => makeBreakdownDimension(e));
  // }, [selectedBreakdowns]);
  // const distinctAdKeyCountMetric = useMemo(() => {
  //   return makeDistinctAdKeyCount();
  // }, []);
  // const { loadData } = useNorthbeamLazyQuery<
  //   GetSalesMetricsReportV4,
  //   GetSalesMetricsReportV4Variables
  // >(SALES_METRICS_REPORT_V4);
  // const { loadData: loadCount } = useNorthbeamLazyQuery<
  //   GetSalesMetricsCountV4,
  //   GetSalesMetricsCountV4Variables
  // >(SALES_METRICS_COUNT_V4);
  // const breakdownOptions = useMemo(() => {
  //   return sortBy(
  //     breakdowns
  //       .filter((e) => !selectedBreakdowns.includes(e.name))
  //       .map((e) => ({ label: e.name, value: e.name })),
  //     ["label"],
  //   );
  // }, [breakdowns, selectedBreakdowns]);
  // const sharedVars = useMemo(() => {
  //   return {
  //     attributionModel,
  //     attributionWindow,
  //     accountingMode,
  //     dateRange: { startDate: "2025-07-01", endDate: "2025-07-07" },
  //     timeGranularity,
  //     level: granularity === "platform" ? "campaign" : granularity,
  //     metricIds: [distinctAdKeyCountMetric.id],
  //   };
  // }, [
  //   attributionModel,
  //   attributionWindow,
  //   accountingMode,
  //   timeGranularity,
  //   granularity,
  //   distinctAdKeyCountMetric,
  // ]);
  // const loadReport = useCallback(
  //   async ({
  //     dimensionIds,
  //     breakdownFilters,
  //     advancedSearch,
  //     page = 0,
  //   }: {
  //     dimensionIds: string[];
  //     breakdownFilters?: SalesTableReportV3BreakdownsFilterInput[];
  //     advancedSearch?: any;
  //     page?: number;
  //   }) => {
  //     const uniqDimensionIds = sortedUniq(dimensionIds);
  //     const [{ data: countData }, { data: rowData }] = await Promise.all([
  //       loadCount({
  //         variables: {
  //           ...sharedVars,
  //           dimensionIds: uniqDimensionIds,
  //           breakdownFilters,
  //           advancedSearch,
  //         },
  //       }),
  //       loadData({
  //         variables: {
  //           ...sharedVars,
  //           dimensionIds: uniqDimensionIds,
  //           breakdownFilters,
  //           advancedSearch,
  //           sorting: [
  //             { metricId: "spend", order: "desc" },
  //             ...uniqDimensionIds.map((e) => ({
  //               dimensionId: e,
  //               order: "asc",
  //             })),
  //           ],
  //           limit: LIMIT,
  //           offset: page * LIMIT,
  //         },
  //       }),
  //     ]);
  //     return {
  //       total: countData?.me.salesMetricsCountV4.total ?? 0,
  //       actual: (rowData?.me.salesMetricsReportV4.actual ??
  //         []) as SalesMetricRow[],
  //       comparison: (rowData?.me.salesMetricsReportV4.comparison ??
  //         []) as SalesMetricRow[],
  //     };
  //   },
  //   [sharedVars],
  // );
  // useEffect(() => {
  //   let cancelled = false;
  //   const placeholderRows = Array.from({ length: 15 }).map((_, index) => ({
  //     type: "spinner" as const,
  //     nesting: "root",
  //     level: 0,
  //     id: `spinner-root-${index}`,
  //   }));
  //   setFlatRows({
  //     root: { page: 0, rows: placeholderRows },
  //   });
  //   const idDimension =
  //     breakdownDimensions.length > 0
  //       ? breakdownDimensions[0]
  //       : makeAdKeyDimension();
  //   const nameDimension =
  //     breakdownDimensions.length > 0
  //       ? breakdownDimensions[0]
  //       : makeNameDimension();
  //   loadReport({
  //     dimensionIds: [idDimension.id, nameDimension.id],
  //   }).then((data) => {
  //     if (cancelled) {
  //       return;
  //     }
  //     const rows: TableRow[] = data.actual.map((row) => ({
  //       type: "report",
  //       nesting: "root",
  //       level: 0,
  //       id:
  //         idDimension.id === "adKey"
  //           ? idDimension.getValue(row)
  //           : jsonHash([
  //               {
  //                 breakdown: idDimension.name,
  //                 value: idDimension.getValue(row),
  //               },
  //             ]),
  //       name: nameDimension.getValue(row) ?? "",
  //       actualMetrics: row.metrics,
  //     }));
  //     if (data.total > data.actual.length) {
  //       rows.push({
  //         type: "load-more",
  //         nesting: "root",
  //         level: 0,
  //         id: "load-more-root",
  //       });
  //     }
  //     setFlatRows((prev) => ({
  //       ...prev,
  //       root: { page: 0, rows },
  //     }));
  //   });
  //   return () => {
  //     cancelled = true;
  //   };
  // }, [loadReport, breakdownDimensions]);
  // const columns = useMemo(() => {
  //   return [
  //     columnHelperWrapper.accessor({
  //       accessorKey: () => "select",
  //       columnDef: {
  //         id: "select",
  //         cell: (cell) => {
  //           const row = cell.row.original;
  //           if (row.type !== "report") {
  //             return null;
  //           }
  //           let isSelected = false;
  //           let isPartiallySelected = false;
  //           const parentIds = findParentRows(
  //             flatRows,
  //             cell.row.original.id,
  //           ).map((e) => e.id);
  //           const reversedIds = [...parentIds, row.id].reverse();
  //           for (const rowId of reversedIds) {
  //             const selection = rowSelection.find((e) => e.id === rowId);
  //             if (selection) {
  //               if (selection.type === "inclusion") {
  //                 isSelected = true;
  //               }
  //               break;
  //             }
  //           }
  //           const childIds = rowSelection.filter((e) =>
  //             e.path.includes(row.id),
  //           );
  //           if (childIds.length > 0) {
  //             isSelected = false;
  //             isPartiallySelected = true;
  //           }
  //           return (
  //             <div className="p-2 flex items-center gap-1">
  //               <div className="text-[0]">
  //                 <IndeterminateCheckbox
  //                   checked={isSelected}
  //                   indeterminate={isPartiallySelected}
  //                   onChange={() => {
  //                     if (rowSelection.map((e) => e.id).includes(row.id)) {
  //                       setRowSelection([
  //                         ...rowSelection.filter(
  //                           (e) => !e.path.includes(row.id) && e.id !== row.id,
  //                         ),
  //                       ]);
  //                     } else {
  //                       const parentIds = findParentRows(flatRows, row.id).map(
  //                         (e) => e.id,
  //                       );
  //                       let closesParentType;
  //                       for (const parentRowId of [...parentIds].reverse()) {
  //                         const parentSelection = rowSelection.find(
  //                           (e) => e.id === parentRowId,
  //                         );
  //                         if (parentSelection) {
  //                           closesParentType = parentSelection.type;
  //                           break;
  //                         }
  //                       }
  //                       setRowSelection([
  //                         ...rowSelection.filter(
  //                           (e) => !e.path.includes(row.id),
  //                         ),
  //                         {
  //                           id: row.id,
  //                           path: parentIds,
  //                           type:
  //                             closesParentType === "inclusion"
  //                               ? "exclusion"
  //                               : "inclusion",
  //                         },
  //                       ]);
  //                     }
  //                   }}
  //                 />
  //               </div>
  //             </div>
  //           );
  //         },
  //       },
  //     }),
  //     columnHelperWrapper.accessor({
  //       accessorKey: (row) => {
  //         return row.type === "report" ? row.name : "";
  //       },
  //       columnDef: {
  //         id: "name",
  //         cell: (cell) => {
  //           const rowType = cell.row.original.type;
  //           const nesting = cell.row.original.nesting;
  //           const level = cell.row.original.level;
  //           const idDimension =
  //             breakdownDimensions[level] ?? makeAdKeyDimension();
  //           const nameDimension =
  //             breakdownDimensions[level] ?? makeNameDimension();
  //           if (rowType === "spinner") {
  //             return <SpinnerCell />;
  //           }
  //           if (rowType === "load-more") {
  //             return (
  //               <LoadMoreCell
  //                 onLoadMore={async () => {
  //                   const nextPage = flatRows[nesting].page + 1;
  //                   let breakdownFilters = [];
  //                   try {
  //                     breakdownFilters = JSON.parse(cell.row.original.nesting);
  //                     // eslint-disable-next-line no-empty
  //                   } catch (e) {}
  //                   setFlatRows((prev) => {
  //                     const newRows = prev[nesting].rows.map((row) =>
  //                       row.type === "load-more"
  //                         ? {
  //                             type: "spinner" as const,
  //                             nesting,
  //                             level,
  //                             id: `spinner-${nesting}-0`,
  //                           }
  //                         : row,
  //                     );
  //                     return cloneDeep({
  //                       ...prev,
  //                       [nesting]: { ...prev[nesting], rows: newRows },
  //                     });
  //                   });
  //                   const data = await loadReport({
  //                     dimensionIds: uniq([idDimension.id, nameDimension.id]),
  //                     breakdownFilters,
  //                     advancedSearch: jsonLogic,
  //                     page: nextPage,
  //                   });
  //                   setFlatRows((prev) => {
  //                     const rowsToAppend: TableRow[] = data.actual.map(
  //                       (row) => ({
  //                         type: "report",
  //                         nesting,
  //                         level,
  //                         id:
  //                           idDimension.id === "adKey"
  //                             ? idDimension.getValue(row)
  //                             : jsonHash([
  //                                 {
  //                                   breakdown: idDimension.name,
  //                                   value: idDimension.getValue(row),
  //                                 },
  //                               ]),
  //                         name: nameDimension.getValue(row) ?? "",
  //                         actualMetrics: row.metrics,
  //                       }),
  //                     );
  //                     const newRows: TableRow[] = [
  //                       ...prev[nesting].rows.filter(
  //                         (e) => e.type === "report",
  //                       ),
  //                       ...rowsToAppend,
  //                     ];
  //                     if (data.total > newRows.length) {
  //                       newRows.push({
  //                         type: "load-more",
  //                         nesting,
  //                         level,
  //                         id: `load-more-${nesting}`,
  //                       });
  //                     }
  //                     return cloneDeep({
  //                       ...prev,
  //                       [nesting]: {
  //                         page: nextPage,
  //                         rows: newRows,
  //                       },
  //                     });
  //                   });
  //                 }}
  //               />
  //             );
  //           }
  //           return (
  //             <NameCell
  //               cell={cell}
  //               row={cell.row.original}
  //               breakdowns={breakdownDimensions}
  //               distinctAdKeyCountMetric={distinctAdKeyCountMetric}
  //             />
  //           );
  //         },
  //       },
  //     }),
  //   ];
  // }, [
  //   columnHelperWrapper,
  //   flatRows,
  //   breakdownDimensions,
  //   distinctAdKeyCountMetric,
  //   jsonLogic,
  //   loadReport,
  // ]);
  // return (
  //   <div className="p-8">
  //     <div className="mb-2 flex items-center gap-2">
  //       {selectedBreakdowns.map((breakdown) => {
  //         return (
  //           <div
  //             key={breakdown}
  //             className={clsx(
  //               "w-48 h-9 border rounded flex items-center gap-2 px-3",
  //               "bg-v2-primary hover:border-v2-primary group",
  //             )}
  //           >
  //             <div className="shrink-0">
  //               <i
  //                 className={clsx(
  //                   "fa-solid fa-grip-dots-vertical text-v2-secondary",
  //                   "text-base opacity-25",
  //                 )}
  //               ></i>
  //             </div>
  //             <div className="text-sm truncate flex-1">{breakdown}</div>
  //             <TertiaryIconButton
  //               className="shrink-0 w-6 h-6"
  //               onClick={() => {
  //                 setRowSelection([]);
  //                 setExpanded({});
  //                 setSelectedBreakdowns(
  //                   selectedBreakdowns.filter((e) => e !== breakdown),
  //                 );
  //               }}
  //             >
  //               <i className="fa-regular fa-trash"></i>
  //             </TertiaryIconButton>
  //           </div>
  //         );
  //       })}
  //       <Autocomplete
  //         size="md"
  //         placeholder="Add Breakdown"
  //         inputWrapperClassName="w-48"
  //         dropdownClassName="w-72"
  //         value={null}
  //         options={breakdownOptions}
  //         onChange={(val) => {
  //           if (val) {
  //             setRowSelection([]);
  //             setExpanded({});
  //             setSelectedBreakdowns([...selectedBreakdowns, val]);
  //           }
  //         }}
  //       />
  //     </div>
  //     <div className="mb-2 font-mono text-xs bg-v2-interstellar/100 p-3 whitespace-pre">
  //       {JSON.stringify(jsonLogic, null, 2)}
  //     </div>
  //     <div className="pb-2 flex items-center gap-4">
  //       <button
  //         onClick={() => {
  //           setJsonLogic(generateSelectionFragment(rowSelection));
  //         }}
  //       >
  //         Generate JSON Logic
  //       </button>
  //       <button
  //         onClick={async () => {
  //           const placeholderRows = Array.from({ length: 15 }).map(
  //             (_, index) => ({
  //               type: "spinner" as const,
  //               nesting: "root",
  //               level: 0,
  //               id: `spinner-root-${index}`,
  //             }),
  //           );
  //           setFlatRows({
  //             root: { page: 0, rows: placeholderRows },
  //           });
  //           const idDimension =
  //             breakdownDimensions.length > 0
  //               ? breakdownDimensions[0]
  //               : makeAdKeyDimension();
  //           const nameDimension =
  //             breakdownDimensions.length > 0
  //               ? breakdownDimensions[0]
  //               : makeNameDimension();
  //           const data = await loadReport({
  //             dimensionIds: [idDimension.id, nameDimension.id],
  //             advancedSearch: jsonLogic,
  //           });
  //           const rows: TableRow[] = data.actual.map((row) => ({
  //             type: "report",
  //             nesting: "root",
  //             level: 0,
  //             id:
  //               idDimension.id === "adKey"
  //                 ? idDimension.getValue(row)
  //                 : jsonHash([
  //                     {
  //                       breakdown: idDimension.name,
  //                       value: idDimension.getValue(row),
  //                     },
  //                   ]),
  //             name: nameDimension.getValue(row) ?? "",
  //             actualMetrics: row.metrics,
  //           }));
  //           if (data.total > data.actual.length) {
  //             rows.push({
  //               type: "load-more",
  //               nesting: "root",
  //               level: 0,
  //               id: "load-more-root",
  //             });
  //           }
  //           setFlatRows((prev) => ({
  //             ...prev,
  //             root: { page: 0, rows },
  //           }));
  //         }}
  //       >
  //         Run this filter
  //       </button>
  //       <button
  //         onClick={() => {
  //           setRowSelection([]);
  //           setJsonLogic(null);
  //         }}
  //       >
  //         Clear selection
  //       </button>
  //     </div>
  //     <Table
  //       columns={columns}
  //       rows={flatRows["root"].rows}
  //       getRowId={(row) => row.id}
  //       getSubRows={(row) => flatRows[row.id]?.rows}
  //       enableSubRowSelection={false}
  //       expanded={expanded}
  //       onExpandedChange={async (val) => {
  //         setExpanded(val);
  //         const expandedRowId = difference(
  //           Object.keys(val),
  //           Object.keys(expanded),
  //         )[0];
  //         const expandedRow = findRow(flatRows, expandedRowId);
  //         if (expandedRow && !flatRows[expandedRow.id]) {
  //           const idJson = JSON.parse(expandedRow.id);
  //           const nesting = expandedRow.id;
  //           const level = expandedRow.level + 1;
  //           setFlatRows((prev) => {
  //             return cloneDeep({
  //               ...prev,
  //               [nesting]: {
  //                 page: 0,
  //                 rows: [
  //                   {
  //                     type: "spinner",
  //                     nesting,
  //                     level,
  //                     id: `spinner-${nesting}-0`,
  //                   },
  //                 ],
  //               },
  //             });
  //           });
  //           const idDimension =
  //             breakdownDimensions[level] ?? makeAdKeyDimension();
  //           const nameDimension =
  //             breakdownDimensions[level] ?? makeNameDimension();
  //           const data = await loadReport({
  //             dimensionIds: uniq([idDimension.id, nameDimension.id]),
  //             breakdownFilters: idJson,
  //             advancedSearch: jsonLogic,
  //             page: 0,
  //           });
  //           setFlatRows((prev) => {
  //             const newRows: TableRow[] = data.actual.map((row) => ({
  //               type: "report",
  //               nesting,
  //               level,
  //               id:
  //                 idDimension.id === "adKey"
  //                   ? idDimension.getValue(row)
  //                   : jsonHash([
  //                       ...idJson,
  //                       {
  //                         breakdown: idDimension.name,
  //                         value: idDimension.getValue(row),
  //                       },
  //                     ]),
  //               name: nameDimension.getValue(row) ?? "",
  //               actualMetrics: row.metrics,
  //             }));
  //             if (data.total > newRows.length) {
  //               newRows.push({
  //                 type: "load-more",
  //                 nesting,
  //                 level,
  //                 id: `load-more-${nesting}`,
  //               });
  //             }
  //             return cloneDeep({
  //               ...prev,
  //               [nesting]: {
  //                 page: 0,
  //                 rows: cloneDeep(newRows),
  //               },
  //             });
  //           });
  //         }
  //       }}
  //     />
  //   </div>
  // );
};

// const NameCell = ({
//   cell,
//   row,
//   breakdowns,
//   distinctAdKeyCountMetric,
// }: {
//   cell: CellContext<TableRow, string>;
//   row: TableReportRow;
//   breakdowns: DimensionDefinition[];
//   distinctAdKeyCountMetric: SalesMetricV2;
// }) => {
//   const level = row.level;
//   const parents = cell.row.getParentRows();
//   const isExpandable = level < breakdowns.length;
//   const names = isExpandable
//     ? [...parents.map((e) => e.getValue("name")), cell.getValue()]
//     : [cell.getValue()];

//   return (
//     <div
//       className="flex items-center gap-2"
//       style={{ paddingLeft: level * (isExpandable ? 20 : 30) + "px" }}
//     >
//       {isExpandable && (
//         <button onClick={() => cell.row.toggleExpanded()}>
//           <i
//             className={clsx("fa-solid", {
//               "fa-chevron-right": !cell.row.getIsExpanded(),
//               "fa-chevron-down": cell.row.getIsExpanded(),
//             })}
//           ></i>
//         </button>
//       )}
//       <span className="text-xs text-nowrap">{names.join(" / ")}</span>
//       <span className="text-xs text-nowrap text-muted">
//         [{distinctAdKeyCountMetric.getValue(row.actualMetrics)}]
//       </span>
//       <span className="text-2xs text-nowrap">{row.id}</span>
//     </div>
//   );
// };

// const SpinnerCell = () => {
//   return <div>loading...</div>;
// };

// const LoadMoreCell = ({ onLoadMore }: { onLoadMore: () => void }) => {
//   return (
//     <div>
//       <button onClick={onLoadMore}>Load more</button>
//     </div>
//   );
// };

// const IndeterminateCheckbox = ({
//   checked,
//   indeterminate,
//   onChange,
// }: {
//   checked: boolean;
//   indeterminate?: boolean;
//   onChange: ChangeEventHandler<HTMLInputElement>;
// }) => {
//   const ref = useRef<HTMLInputElement>(null);

//   useEffect(() => {
//     if (ref.current) {
//       ref.current.indeterminate = Boolean(indeterminate);
//     }
//   }, [indeterminate]);

//   return <CustomCheckbox ref={ref} checked={checked} onChange={onChange} />;
// };

// function findRow(flatRows: Record<string, NestingState>, id: string) {
//   return Object.values(flatRows)
//     .flatMap((e) => e.rows)
//     .find((e) => e.id === id);
// }

// function findParentRow(flatRows: Record<string, NestingState>, id: string) {
//   const row = findRow(flatRows, id);

//   if (row) {
//     return findRow(flatRows, row.nesting);
//   } else {
//     return undefined;
//   }
// }

// function findParentRows(flatRows: Record<string, NestingState>, id: string) {
//   const parents = [];
//   let row = findParentRow(flatRows, id);

//   while (row) {
//     parents.push(row);
//     row = findParentRow(flatRows, row.id);
//   }

//   return parents.reverse();
// }

// function generateSelectionFragment(rowSelection: RowSelection[]) {
//   const selections = rowSelection
//     .map((e) => {
//       const parsedId = JSON.parse(e.id);
//       const isBreakdown = Array.isArray(parsedId);

//       if (isBreakdown) {
//         return parsedId.map((pi) => JSON.stringify(pi));
//       } else {
//         const longestPath = e.path[e.path.length - 1];
//         const parsedLongestPath: any[] = JSON.parse(longestPath);
//         return [...parsedLongestPath.map((e) => jsonHash(e)), e.id];
//       }
//     })
//     .toSorted((a, b) => b.length - a.length);
//   const processedPaths: string[] = [];

//   const generateJsonLogicFragment = (
//     subSelections: string[][],
//     index: number,
//     parent: string,
//   ) => {
//     const output = [];
//     let logicalOperator = "or";
//     let isExclusion = false;

//     for (const sub of subSelections) {
//       const path = sub[index];

//       if (processedPaths.includes(path)) {
//         continue;
//       }

//       const parsedPath = JSON.parse(path);
//       const isBreakdown = "breakdown" in parsedPath;

//       const selectionId = isBreakdown
//         ? `[${compact([parent, path]).join(",")}]`
//         : path;
//       const selectionType = rowSelection.find(
//         (e) => e.id === selectionId,
//       )?.type;

//       const relatedSubSelection = subSelections.filter(
//         (e) => e[index] === path && e.length > index + 1,
//       );

//       let operator = "==";
//       isExclusion = selectionType === "exclusion";

//       if (isExclusion) {
//         operator = "!=";
//         logicalOperator = "and";
//       }

//       const variable = isBreakdown
//         ? `breakdown:${parsedPath.breakdown}`
//         : "adKey";
//       const value = isBreakdown ? parsedPath.value : path;

//       let fragment: any = {
//         [operator]: [{ var: variable }, value],
//       };

//       if (relatedSubSelection.length > 0) {
//         const [res, isChildExclusion] = generateJsonLogicFragment(
//           relatedSubSelection,
//           index + 1,
//           compact([parent, path]).join(","),
//         );

//         if (!selectionType && isChildExclusion) {
//           isExclusion = true;
//           fragment = { "!=": fragment["=="] };
//         }

//         if (isExclusion) {
//           fragment = {
//             or: [
//               fragment,
//               { and: [{ ["=="]: [{ var: variable }, value] }, res] },
//             ],
//           };
//         } else {
//           fragment = { and: [fragment, res] };
//         }
//       }

//       output.push(fragment);

//       processedPaths.push(path);
//     }

//     return [{ [logicalOperator]: output }, isExclusion];
//   };

//   const [res, _] = generateJsonLogicFragment(selections, 0, "");

//   return res;
// }
